module.exports = __webpack_public_path__ + "static/logo_generali_rvb-446cfdb0a15cb7a715a15a3146233b3f.svg";